import { useTranslations } from 'next-intl';
import React from 'react';

import Button from '@cineamo/ui/src/button/Button';
import { ButtonStyle } from '@cineamo/ui/src/button/ButtonStyle.enum';
import { IconUpArrow16 } from '@cineamo/ui/src/icons/ic-upArrow';

/**
 * Reusable back-to-top button component.
 * Scrolls the page smoothly to the top when clicked.
 */
const BackToTopButton: React.FC<{
    className?: string;
}> = ({ className }) => {
    const t = useTranslations();

    const handleClick = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <div className={className || 'block'}>
            <Button
                className="mx-auto py-16 font-bold"
                style={ButtonStyle.frameless}
                onClick={handleClick}
                leadingIcon={<IconUpArrow16 />}>
                {t('common.back-to-top')}
            </Button>
        </div>
    );
};

export default BackToTopButton;
